import { useRunOnce } from '@fabric-app/hooks/useRunOnce';
import { getLocalFileSyncTenantId } from '../utils/getLocalFileSyncTenantId';
import { useState } from 'react';
import { isDesktopApp } from '@todesktop/client-core/platform/todesktop';

export const useDesktopFileSyncTenantId = () => {
  const [tenantId, setTenantId] = useState<string | null>(null);

  useRunOnce(
    async () => {
      const tenantId = await getLocalFileSyncTenantId();
      setTenantId(tenantId);
    },
    {
      condition: isDesktopApp(),
    },
  );

  return tenantId;
};
